import catdrop from '@assets/images/catdrop.png';
import arrow_down from '@assets/images/arrow_down.svg';
import orange_arrow from '@assets/images/orange_arrow.svg';
import blue_arrow from '@assets/images/blue_arrow.svg';
import white_arrow from '@assets/images/white_arrow.svg';
import white_arrow_down from '@assets/images/white_arrow_down.svg';

export const heroSlides = [
  {
    id: 'hero1',
    linkType: 'internal',
    to: '/about',
    titleLines: ['Fund raising for everyone'],
    textWrap: 'with NFTs as rewards',
    mobileTextWrap: 'Fund raising for everyone with NFTs as rewards',
    arrowImage: blue_arrow,
    scrollDownVisible: true,
    scrollDownHidden: false,
    arrowDownImage: arrow_down,
    whiteText: false,
  },
  {
    id: 'hero7',
    linkType: 'external',
    href: 'https://venezuelaearthquake.fundraisin.app',
    titleLines: ['Venezuela: A nation in rubble,'],
    textWrap: 'a people who won\'t break',
    mobileTextWrap: 'Venezuela: A nation in rubble, a people who won\'t break',
    arrowImage: white_arrow,
    scrollDownVisible: true,
    scrollDownHidden: true,
    arrowDownImage: white_arrow_down,
    whiteText: true,
  },
  {
    id: 'hero2',
    linkType: 'external',
    href: import.meta.env.VITE_MARKETPLACE_OCTOPI_LINK,
    titleLines: ['Let\'s save the oceans with'],
    textWrap: 'The Ocean Conservancy',
    mobileTextWrap: 'Let\'s save the oceans with The Ocean Conservancy',
    arrowImage: orange_arrow,
    scrollDownVisible: true,
    scrollDownHidden: true,
    arrowDownImage: arrow_down,
    whiteText: false,
  },
  {
    id: 'hero3',
    linkType: 'external',
    href: import.meta.env.VITE_MARKETPLACE_CATDROPS_LINK,
    titleLines: ['Let\'s save the animals with'],
    textWrap: 'FUNPROBIANI',
    mobileTextWrap: 'Let\'s save the animals with FUNPROBIANI',
    arrowImage: blue_arrow,
    bannerImage: catdrop,
    bannerAlt: 'catdrop',
    scrollDownVisible: true,
    scrollDownHidden: true,
    arrowDownImage: arrow_down,
    whiteText: false,
  },
  {
    id: 'hero4',
    hidden: true,
    linkType: 'external',
    href: import.meta.env.VITE_MARKETPLACE_EARTHQUAKE_LINK,
    titleLines: ['Turkiye is struggling with the earthquake disaster'],
    textWrap: 'and we\'re calling for your help!',
    mobileTextWrap: 'Turkiye is struggling with the earthquake disaster and we\'re calling for your help!',
    arrowImage: white_arrow,
    scrollDownVisible: true,
    scrollDownHidden: true,
    arrowDownImage: white_arrow_down,
    whiteText: true,
  },
  {
    id: 'hero5',
    linkType: 'external',
    href: import.meta.env.VITE_CREATOR_TOOLS_LINK,
    titleLines: ['Artists! Sponsors! Create your own Art Packs'],
    textWrap: 'and Campaigns with Creator Tools!',
    mobileTextWrap: 'Artists! Sponsors! Create your own Art Packs and Campaigns with Creator Tools!',
    arrowImage: blue_arrow,
    scrollDownVisible: true,
    scrollDownHidden: true,
    arrowDownImage: arrow_down,
    whiteText: false,
  },
  {
    id: 'hero6',
    hidden: true,
    linkType: 'external',
    href: import.meta.env.VITE_MARKETPLACE_HALLOWEEN_LINK,
    titleLines: [],
    textWrap: 'Trick or Treat, Avalanche Community!',
    mobileTextWrap: 'Trick or Treat, Avalanche Community!',
    arrowImage: white_arrow,
    infoParagraph: 'Celebrate Halloween with us — mint your spooky pumpkin and help us beta test.</br>All proceeds go toward buying candy for kids!',
    mobileInfoParagraph: 'Celebrate Halloween with us — mint your spooky pumpkin and help us beta test. All proceeds go toward buying candy for kids!',
    scrollDownVisible: true,
    scrollDownHidden: true,
    arrowDownImage: white_arrow_down,
    whiteText: true,
  },
];
